import { del } from "../../../../http";
import { FavouriteItem, FavouriteItemType } from "../../../types";

import { favouritesBaseApiUrl } from "../../favouritesBaseUrl";
import { favouriteBulkUrl } from "../../queries/favouriteItems/favouriteItems.constants";

export const deleteFavourite = async (item: FavouriteItem) => {
  if (item.type === FavouriteItemType.Map || item.type === FavouriteItemType.Slide) {
    await del(`${favouritesBaseApiUrl}/favourites/${item.id}`);
  }
  if (item.type === FavouriteItemType.BulkExport || item.type === FavouriteItemType.SavedBulkExport) {
    await del(`${favouriteBulkUrl}/${item.id}`);
  }
};
